var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "themePicker" }, [
    _vm.isLoading
      ? _c("div", { staticClass: "loadWrapper" }, [
          _c("div", { staticClass: "loading" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("loading")))]),
            _vm._v(" "),
            _c("div", { staticClass: "loadingBar" }),
          ]),
        ])
      : _c(
          "ul",
          { staticClass: "picker two" },
          _vm._l(_vm.collection, function (themeModel) {
            return _c("ThemePickerItemView", {
              key: themeModel.id,
              staticClass: "pickerItem",
              attrs: { "theme-model": themeModel },
              on: {
                imageLoaded: _vm.imageLoaded,
                selectTheme: _vm.selectTheme,
              },
            })
          }),
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }